import { BRAND, WHATSAPP_URL, MAILTO_URL } from "@/data/site";
import { Logo } from "@/components/site/Logo";
import { useI18n } from "@/i18n";

export const Footer = () => {
  const year = new Date().getFullYear();
  const { t } = useI18n();
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 bg-ink-900"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-12 sm:px-8 md:flex-row md:items-center md:justify-between">
        <div>
          <div className="flex items-center gap-2.5">
            <Logo size={30} />
            <div className="font-display text-2xl font-extrabold tracking-tight text-white">
              {BRAND.short}
              <span className="text-cyan-neon">.</span>
              <span className="ml-2 font-mono text-xs font-normal uppercase tracking-[0.25em] text-white/40">
                Technology
              </span>
            </div>
          </div>
          <p className="mt-3 max-w-sm font-body text-sm text-white/45">
            {BRAND.tagline}. {t("footer.tag")}
          </p>
        </div>

        <div className="flex gap-6 font-mono text-xs uppercase tracking-widest text-white/50">
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="transition-colors hover:text-cyan-neon" data-testid="footer-whatsapp">
            WhatsApp
          </a>
          <a href={MAILTO_URL} className="transition-colors hover:text-cyan-neon" data-testid="footer-email">
            Email
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-5 text-center font-mono text-[11px] uppercase tracking-widest text-white/30 sm:flex-row sm:justify-between sm:px-8 sm:text-left">
          <span>© {year} {BRAND.name}. {t("footer.rights")}</span>
          <span>{BRAND.website} · {BRAND.region} · Național & Remote</span>
        </div>
      </div>
    </footer>
  );
};
